export default {
  id: '',
  nombre: '',
  iut: '',
  correo: '',
  alias: '',
  cargo: '',
  avatar: '',
  token: '',
  ultimoUso: 0,
  vencimiento: 0,
  roles: [],
  permisos: [],
  empresas: [],
  verificationCode: '',
  loading: false,
  fromCu: false,
  successAction: {
    show: false,
    message: ''
  },
  sharedFile: {}
};
